// Smooth scroll utility with easing
export const smoothScrollTo = (elementId, offset = 100) => {
  const element = document.getElementById(elementId)
  if (!element) return

  const elementPosition = element.getBoundingClientRect().top
  const offsetPosition = elementPosition + window.pageYOffset - offset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  })
}

// Enhanced smooth scroll with custom easing
export const iceSmoothScroll = (target, duration = 1200) => {
  const targetElement = typeof target === 'string' 
    ? document.querySelector(target) 
    : target
  
  if (!targetElement) return

  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 100
  const startPosition = window.pageYOffset
  const distance = targetPosition - startPosition
  let startTime = null

  // Easing function - easeOutCubic for smooth deceleration
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const progress = Math.min(timeElapsed / duration, 1)
    
    const ease = easeOutCubic(progress)
    window.scrollTo(0, startPosition + distance * ease)

    if (progress < 1) {
      requestAnimationFrame(animation)
    }
  }

  requestAnimationFrame(animation)
}

// Scroll to top with ice smooth easing
export const scrollToTop = (duration = 800) => {
  const startPosition = window.pageYOffset
  const distance = -startPosition
  let startTime = null

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const progress = Math.min(timeElapsed / duration, 1)
    const ease = easeOutCubic(progress)
    window.scrollTo(0, startPosition + distance * ease)
    if (progress < 1) {
      requestAnimationFrame(animation)
    }
  }

  requestAnimationFrame(animation)
}
